'use es6';

export function isUngatedFor({
  gates = []
}, ...gateKeys) {
  return gateKeys.every(gateKey => gates.includes(gateKey));
}